import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

export const Stats = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const items = [
    {
      value: '100%',
      label: 'client satisfaction rate.',
      stars: true,
    },
    {
      value: '65+',
      label: 'businesses served.',
    },
    {
      value: '200+',
      label: 'video ads produced every month.',
    },
  ];

  return (
    <section className="section bg-primary" ref={ref}>
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl shadow-2xl grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-dashed divide-slate-300 overflow-hidden"
        >
          {items.map((item, i) => (
            <div key={i} className="flex flex-col items-center justify-center text-center py-12 px-6">
              <p className="text-5xl md:text-6xl font-bold text-foreground">
                {item.value}
              </p>
              <p className="mt-2 text-base md:text-lg text-foreground/70 font-medium">
                {item.label}
              </p>
              {item.stars && (
                <div className="flex items-center gap-2 mt-3">
                  <span className="text-sm font-semibold text-slate-700">5.0/5</span>
                  <div className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, j) => (
                      <span key={j} className="text-yellow-400 text-lg">★</span>
                    ))}
                  </div>
                  <span className="text-sm font-semibold text-slate-700">Google</span>
                </div>
              )}
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-10"
        >
          <a href="/#contact" className="btn-hero-accent">
            Blow up my brand
          </a>
        </motion.div>
      </div>
    </section>
  );
};
